import AppReducer from "./reducer";
import IntialState from "./intial.state";

import {applyMiddleware, createStore} from "redux";
//import undoMiddleware from './middlewares/undo.middleware'
import thunk from "redux-thunk";
import i18n, { supportedLanguages } from "../i18n";

const detectedLanguage = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
const currentLanguage =
    supportedLanguages.find(({ code }) => code === detectedLanguage)?.code || "en";

/**
 * Initialise the application  store and reducers
 */
const store = createStore(
    AppReducer,
    {
        ...IntialState,
        application: {...IntialState.application, currentLanguage},
    },
    applyMiddleware(thunk)
);

// Redux owns the selected language; i18next renders the corresponding UI copy.
store.subscribe(() => {
    const language = store.getState().application.currentLanguage;
    if (i18n.resolvedLanguage !== language) {
        void i18n.changeLanguage(language);
    }
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
